/**
 * @file iconMapper.js
 * @description Icon mapper component for displaying and managing icon mapper.
 * @component IconMapper
 * @exports IconMapper - Main component for displaying and managing icon mapper.
 */

import {
    SpeedRounded as SpeedRoundedIcon,
    People as PeopleIcon,
    UploadFile as UploadFileIcon,
    DataUsage as DataUsageIcon,
    Chat as ChatIcon,
    Payment as PaymentIcon,
    QuestionAnswerOutlined as QuestionAnswerOutlinedIcon,
    Campaign as CampaignIcon,
    Settings as SettingsIcon,
    MarkEmailUnreadOutlined as MarkEmailUnreadOutlinedIcon,
    Portrait as PortraitIcon,
    HeadsetMicOutlined,
    Textsms,
    PhoneInTalk as PhoneInTalkIcon,
    Voicemail as VoicemailIcon,
    CallReceived as CallReceivedIcon,
    SpaceDashboard as SpaceDashboardIcon,
    ViewQuilt as ViewQuiltIcon,
    SupervisorAccount as SupervisorAccountIcon,
    AdminPanelSettings as AdminPanelSettingsIcon,
    Forum as ForumIcon,
    ChatBubbleOutline as ChatBubbleOutlineIcon,
    DonutLarge as DonutLargeIcon,
    Sms as SmsIcon,
    Message as MessageIcon,
    TrackChanges as TrackChangesIcon,
    TrendingUp as TrendingUpIcon,
    Storage as StorageIcon,
    LockOpen as LockOpenIcon,
    Badge as BadgeIcon,
    Psychology as PsychologyIcon,
    Group as GroupIcon,
    SupervisedUserCircle as SupervisedUserCircleIcon,
    Policy as PolicyIcon,
    AddToQueue as AddToQueueIcon,
    Engineering as EngineeringIcon,
    AssignmentInd as AssignmentIndIcon,
    AssignmentTurnedIn as AssignmentTurnedInIcon,
  } from "@mui/icons-material";
  
  const iconMapping = {
    SpeedRoundedIcon,
    PeopleIcon,
    UploadFileIcon,
    DataUsageIcon,
    ChatIcon,
    PaymentIcon,
    QuestionAnswerOutlinedIcon,
    CampaignIcon,
    SettingsIcon,
    MarkEmailUnreadOutlinedIcon,
    PortraitIcon,
    HeadsetMicOutlined,
    Textsms,
    PhoneInTalkIcon,
    VoicemailIcon,
    CallReceivedIcon,
    SpaceDashboardIcon,
    ViewQuiltIcon,
    SupervisorAccountIcon,
    AdminPanelSettingsIcon,
    ForumIcon,
    ChatBubbleOutlineIcon,
    DonutLargeIcon,
    SmsIcon,
    MessageIcon,
    TrackChangesIcon,
    TrendingUpIcon,
    StorageIcon,
    LockOpenIcon,
    BadgeIcon,
    PsychologyIcon,
    GroupIcon,
    SupervisedUserCircleIcon,
    PolicyIcon,
    EngineeringIcon,
    AddToQueueIcon,
    AssignmentIndIcon,
    AssignmentTurnedInIcon,
  };
  
  export default function getIconComponent(iconName) {
    return iconMapping[iconName] || LockOpenIcon;
  }
  